import isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';
import { menuDefine } from '@/constants/menu';
import loginAPI from '@/api/login';
import { setRoutingEventDatetime } from '@/utils/router';
import { closeOpenFramePopup } from '@/utils/popup';
import router from './router';
import store from './store';

//
// function hasPermission(roles, permissionRoles) {
//   if (roles.indexOf('admin') >= 0) return true
//   if (!permissionRoles) return true
//   return roles.some(role => permissionRoles.indexOf(role) >= 0)
// }

const PATH_LOGIN = '/login';
const whiteList = [PATH_LOGIN]; // no redirect whitelist

/**
 * 쿼리 스트링으로 전달된 조건을 확인하고 처리한다.
 * @author Ju
 * @param  {[type]} route [description]
 * @return {[type]}       [description]
 */
function checkQueryParams(route, next) {
  if (!isEmpty(route.query)) {
    const query = route.query;
    // 성능/운영 분석 시간 설정
    if (has(query, 'eventDatetime')) {
      setRoutingEventDatetime(store, parseInt(query.eventDatetime, 10));
    }
    // 관리대상 관련 링크를 통해 라우팅됐는지 여부
    if (has(query, 'isLinkRoute') && query.isLinkRoute === 'true') {
      store.dispatch('setIsLinkRoute', true);
    }
    if (has(query, 'syslogRuleId')) {
      store.dispatch('setSyslogRuleId', query.syslogRuleId);
    }
    // 차트 템플릿
    if (has(query, 'chartTemplateSeq')) {
      store.dispatch('setInitChartTemplateSeq', query.chartTemplateSeq);
    }
  }
  if (route.path.indexOf(menuDefine.TOPOLOGYMAP) >= 0) {
    next();
  } else {
    // 토폴로지맵을 제외한 메뉴는 query string을 제거한다.
    next(route.path);
  }
}

/**
 * 라우터 beforeEach hook
 * 허가된 url 여부 확인 / 라우트 전환 전 전 처리를 수행한다.
 * @type {[type]}
 */
router.beforeEach((to, from, next) => {
  closeOpenFramePopup();
  if (!isEmpty(store.getters.userInfo)) {
    if (to.path === PATH_LOGIN) {
      next({
        path: '/',
      });
    } else if (!isEmpty(to.query)) {
      checkQueryParams(to, next);
    } else {
      next();
    }
  } else if (whiteList.indexOf(to.path) !== -1) {
    loginAPI.getCustomerId().then((response) => {
      if (response.data.success && !isEmpty(response.data.data)) {
        const data = response.data.data;
        store.commit('setCustomerId', data);
        next();
      } else {
        next();
      }
    }).catch(() => {
      next();
    });
  } else {
    // session check
    loginAPI
      .checkLogin()
      .then((response) => {
        const result = response.data;
        if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
          const data = response.data.data;
          store.dispatch('setUserInfo', data.userInfo);
          store.dispatch('setRoles', data.roles);
          if (!isEmpty(to.query)) {
            checkQueryParams(to, next);
          } else {
            next();
          }
        } else {
          next(PATH_LOGIN);
        }
      })
      .catch(() => {
        next(PATH_LOGIN);
      });
  }
});

// router.afterEach(() => {
// });



// WEBPACK FOOTER //
// ./src/permission.js